import React,{useEffect,useRef} from "react";
import css from "./SideBarNavigator.module.css";
import {isTouchDevice,capitalize} from "vritra";
import {SideBarNavigator as Component} from "react-vritra";
import {useRouteHash} from "Resources";
import * as H from "./Hooks";


export default function SideBarNavigator(props){
    const {tintColor,onNavigate,initialId}=props,domref=useRef();
    const routehash=useRouteHash(),entryId=H.useLocationHash(initialId);
    useEffect(()=>{
        const element=domref.current;
        if(element){
            const entry=element.getCurrentEntry();
            entry&&setDocumentTitle(entry);
        }
    },[]);
    return <Component
        {...props}
        domref={domref}
        entryId={entryId}
        onNavigate={(current,previous)=>{
            setDocumentTitle(current);
            location.replace(`#${routehash}#${current.id}`);
            onNavigate&&onNavigate(current.id,previous?.id);
        }}
        className={css.sidebarnavigator+" "+(props.className||"")}
        sidebarClassName={css.sidebar+" "+(props.sidebarClassName||"")}
        containerClassName={css.container+" "+(props.containerClassName||"")}
        folderColor={textColor}
        endpointColor={textColor}
        tintColor={tintColor||minorColor}
        sidebarShown={!isTouchDevice()}
        sideBarScrollTheme="light"
    />
}

const setDocumentTitle=(entry)=>{
    document.title=capitalize(entry.name||entry.id)+" \u2022 Vritra";
}
